import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Allow-list of query params that carry benign date/plan intent. Any host,
// payment, or booking-code parameters are intentionally stripped so a raw
// widget bypass cannot be constructed by tampering with the URL.
const SAFE_QUERY_KEYS = new Set([
  "date",
  "dates",
  "start_date",
  "end_date",
  "checkin",
  "checkout",
  "plan",
  "nights",
  "guests",
  "adults",
  "children",
]);

function buildTarget(base: string, search: string): string {
  try {
    const src = new URLSearchParams(search);
    const out = new URLSearchParams();
    for (const [k, v] of src.entries()) {
      if (SAFE_QUERY_KEYS.has(k.toLowerCase())) out.set(k, v);
    }
    const qs = out.toString();
    if (!qs) return base;
    return base + (base.includes("?") ? "&" : "?") + qs;
  } catch {
    return base;
  }
}

// Minimal safe replace redirect to an external URL. Used to route legacy
// aliases for sister modern/protected properties to their official guarded
// booking page instead of rendering a raw Checkfront/Droplet widget.
export function ExternalReplace({ to }: { to: string }) {
  const { search } = useLocation();
  useEffect(() => {
    const target = buildTarget(to, search);
    window.location.replace(target);
  }, [to, search]);
  return null;
}

export default ExternalReplace;